//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/TemplateTestManager.js";
let d=[[],[[["testName","version","errorCodes","bool0","int0","float0","features0","nxobjects0","strings0"],"RunSampleTemplateTest",{},9,0],[["testName","version","errorCodes","line0"],"RunLinetest",{},4,0],[["testName","version","errorCodes","selectobject0"],"RunPrintObjectAttributes",{},4,0],[["testName","version","errorCodes","a00","a11"],"RunParameterAxis",{},5,0],[["testName","version","errorCodes","pl00","pl11"],"RunParameterPlane",{},5,0],[["testName","version","errorCodes","p10","p21"],"RunParameterPoint",{},5,0],[["testName","version","errorCodes","statisticsViewType","toleranceType","tolerance"],"RunVisualizationStatistics",{},6,0],[["testName","version","errorCodes","paxFileSpec"],"RunVisualizationSetup",{},4,0],[["testName","version","errorCodes"],"RunVisualizationSettingsTest",{},3,0]],[]];
SPLM.ArchTemplateTestManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.ArchTemplateTestManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.ArchTemplateTestManager.StatisticsViewType = Object.freeze({
    "WorkView" : "WorkView", "DisplayedPartViews" : "DisplayedPartViews", "AllDisplayedViews" : "AllDisplayedViews"});

SPLM.ArchTemplateTestManager.ToleranceType = Object.freeze({
    "Standard" : "Standard", "Custom" : "Custom"});

export default SPLM;